import createDefaultClient from '~/lib/graphql';

export const graphqlClient = createDefaultClient();
